export const technologiesData = [
    {
        id: 1,
        html_content: <i className="fa-brands fa-html5 fa-2xl hover"></i>,
        text: 'HTML5'
    },
    {
        id: 2,
        html_content: <i className="fa-brands fa-css3-alt fa-2xl hover"></i>,
        text: 'CSS3'
    },
    {
        id: 3,
        html_content: <i className="fa-brands fa-js fa-2xl hover"></i>,
        text: 'JavaScript'
    },
    {
        id: 4,
        html_content: <i className="fa-brands fa-node fa-2xl hover"></i>,
        text: 'Node.js'
    },
    {
        id: 5,
        html_content: <i className="fa-brands fa-react fa-2xl hover"></i>,
        text: 'React.js'
    },
    {
        id: 6,
        html_content: <i className="fa-brands fa-python fa-2xl hover"></i>,
        text: 'Python'
    },
    {
        id: 7,
        html_content: <i className="fa-brands fa-laravel fa-2xl hover"></i>,
        text: 'Laravel'
    },
    {
        id: 8,
        html_content: <i className="fa-brands fa-github fa-2xl hover"></i>,
        text: 'GitHub'
    },
    {
        id: 9,
        html_content: <i className="fa-brands fa-git-alt fa-2xl hover"></i>,
        text: 'Git'
    },
    {
        id: 10,
        html_content: <i className="fa-brands fa-docker fa-2xl hover"></i>,
        text: 'Docker'
    },
    {
        id: 11,
        html_content: <i className="fa-solid fa-database fa-2xl hover"></i>,
        text: 'Database (MS SQL, MySQL, MongoDB)'
    },
    {
        id: 12,
        html_content: <i className="fa-brands fa-wix fa-2xl hover"></i>,
        text: 'Wix'
    },
    {
        id: 13,
        html_content: <i className="fa-brands fa-wordpress fa-2xl hover"></i>,
        text: 'WordPress'
    },
    {
        id: 14,
        html_content: <i className="fa-brands fa-shopify fa-2xl hover"></i>,
        text: 'Shopify'
    },
    {
        id: 15,
        html_content: <i className="fa-brands fa-flutter fa-2xl hover"></i>,
        text: 'Flutter'
    },
];